import * as commonLib from './common.js';
commonLib.setCurrentPage('sdcPageLink');
